<template>
  <div class="d-flex justify-content-around container-fluid">
    <div class="col-4 card">
      <div class="card-header">
        <h4>CentralGym - PoS</h4>
      </div>
      <div class="card-body d-flex flex-column">
        <div class="d-flex flex-row mb-0 mt-auto">
          <div class="col-4 d-flex flex-column justify-content-aournd">
            <p class="mr-0 ml-auto pr-0 pl-auto">Versión</p>
            <p class="mr-0 ml-auto pr-0 pl-auto">S.O.</p>
          </div>
          <div class="d-flex col-8 flex-column">
            <div class="d-flex">
              <p class="bg-success px-2 py-1 text-light rounded-pill mb-2">
                3.35.09
              </p>
            </div>
            <div class="d-flex">
              <p class="bg-success px-2 py-1 text-light rounded-pill">
                WINDOWS <i class="fa fa-windows" aria-hidden="true"></i>
              </p>
            </div>
          </div>
        </div>
        <a
          class="btn btn-info py-1 mb-2"
          href="https://2tec.cl/instaladores/MasterControl%20Pass/Setup%20-%20MasterControl%20Pass%20v3.35.09%20-%20Visualizer%20v3.11.82%20%2b%20StandAlone%20v1.3.exe"
          download
        >
          <h2 class="py-0 my-auto">
            <i class="fa fa-cloud-download py-0" aria-hidden="true"></i>
          </h2>
        </a>
      </div>
    </div>
    <div class="col-4 card">
      <div class="card-header">
        <h4>[ACTUALIZACIÓN]<br />CentralGym - PoS</h4>
      </div>
      <div class="card-body d-flex flex-column">
        <div class="d-flex flex-row">
          <div class="col-4 d-flex flex-column justify-content-aournd">
            <p class="mr-0 ml-auto pr-0 pl-auto">Versión</p>
            <p class="mr-0 ml-auto pr-0 pl-auto">S.O.</p>
          </div>
          <div class="d-flex col-8 flex-column">
            <div class="d-flex">
              <p class="bg-success px-2 py-1 text-light rounded-pill mb-2">
                3.36.11
              </p>
            </div>
            <div class="d-flex">
              <p class="bg-success px-2 py-1 text-light rounded-pill">
                WINDOWS <i class="fa fa-windows" aria-hidden="true"></i>
              </p>
            </div>
          </div>
        </div>
        <a
          class="btn btn-info py-1 mb-2 mt-auto"
          href="https://2tec.cl/instaladores/MasterControl%20Pass/Actualizacion%20MasterControl%20Pass%20v3.36.11%20%2b%20Visualizer%20v3.13.89%20%2b%20StandAlone%20v1.3.exe"
          download
        >
          <h2 class="py-0 my-auto">
            <i class="fa fa-cloud-download py-0" aria-hidden="true"></i>
          </h2>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$swal.close();
  },
};
</script>

<style></style>
